import trackMissedKeys from './trackMissedKeys'

function translateWithMissedKeysDetection(originalTranslateFn) {
  function translate(...args) {
    const [key, options = {}] = args

    trackMissedKeys(key)

    // Call original translate function
    const result = originalTranslateFn.bind(I18n)(...args)

    // Handle null translations (from translation.io empty values)
    if (result === null) {
      const fallbackLocale = I18n.fallbacks?.[I18n.locale] || I18n.defaultLocale
      return I18n.t(key, {...options, locale: fallbackLocale})
    }

    // Handle missing pluralization translations
    const isMissing = typeof result === 'string' && result.startsWith('[missing') && result.includes('translation]')
    const isPlural = options.count !== undefined && typeof result === 'string'
    if (isMissing && isPlural) {
      const fallbackLocale = I18n.fallbacks?.[I18n.locale] || I18n.defaultLocale
      return I18n.t(key, {...options, locale: fallbackLocale})
    }

    return result
  }

  return translate
}

export default translateWithMissedKeysDetection
